// removed by extract-text-webpack-plugin
module.exports = {"bio":"bio__30Kg6","bioText":"bioText__7lIIl","arrow":"arrow__232UD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Bio/styles.scss
// module id = 241
// module chunks = 0